import PlaceholderPicture from '@assets/images/placeholder.png';
import { useTruncate } from '@hooks/useTruncate';
import { Avatar, Button, CardMedia } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SpecialistCard = ({ specialist, onSelect, onClick }: any) => {
	const { t } = useTranslation();
	const { truncate } = useTruncate();
	const specialistProfilePicture = specialist?.profile_image
		? specialist?.profile_image
		: PlaceholderPicture;

	return (
		<div className="border bg-white flex max-sm:flex-col items-center py-4 px-5 rounded-lg shadow-md gap-5 w-full">
			<div className="flex flex-row max-xxs:flex-col items-center gap-5 w-full">
				<CardMedia
					onClick={onClick}
					component="img"
					image={specialistProfilePicture}
					alt={specialist?.first_name}
					sx={{
						width: 103,
						height: 103,
						borderRadius: '12px',
						objectFit: 'cover',
						cursor: 'pointer',
					}}
				/>
				<div className="flex w-full flex-col">
					<span
						className="text-primary underline font-bold text-xl leading-[28px] cursor-pointer"
						onClick={onClick}
					>
						{truncate(`${specialist?.first_name} ${specialist?.last_name}`, 20)}
					</span>
					<div className="flex flex-col">
						<div className="flex justify-between items-center w-full mt-2">
							<div className="flex flex-col items-start justify-center">
								<div className="flex items-center justify-center gap-2">
									<Avatar
										sx={{ width: 16, height: 12, borderRadius: '2px' }}
										src={`https://flagcdn.com/w40/${specialist?.country.alhpa_two.toLowerCase()}.png`}
									/>
									<span className="text-dark font-normal text-xs">{specialist?.country.name}</span>
								</div>
							</div>
							<div className="flex items-center justify-center gap-2 max-sm:hidden">
								<Button variant="contained" onClick={onSelect}>
									{t('select')}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="hidden items-center justify-center gap-2 max-sm:flex w-full">
				<Button variant="contained" onClick={onSelect} sx={{ width: '100%' }}>
					{t('select')}
				</Button>
			</div>
		</div>
	);
};

export default SpecialistCard;
